/**
 * Shared margin-to-color mapping for classification confidence visualizations.
 * Used by both the confidence histogram strip plot and the confidence/margin scatter
 * so that a given margin value always renders the same color across charts.
 */
export function marginToColor(margin: number): string {
  return `hsl(${Math.min(margin, 0.1) * (120 / 0.1)}, 80%, 45%)`;
}
